export class GridSelectedFilter {
    field: string = '';
    condition: string = '';
    value: string = '';
}